import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import {
  CREATE_DELIVERY_USER,
  GET_DELIVERY_USER_LIST,
  GET_QRTILLDETAILS,
} from '../../../Types'

export const addDeliveryUser = (formValues) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post("api/User/AddDeliveryUser", formValues);

    if (data.response) {
      dispatch({
        type: CREATE_DELIVERY_USER,
        payload: data.response,
      });
    }

    dispatch(hideLoading());

    if (data.statusCode === 400) {
      toast.error(data.message);
      return false; // explicitly return
    } else {
      toast.success("User added successfully");
      return true; // explicitly return
    }
  } catch (error) {
    dispatch(hideLoading());

    if (error.response) {
      if (error.response.status === 401) {
        logout();
        history.push("/login");
        history.go("/login");
      } else if (
        error.response.status === 400 &&
        error.response.data.errors
      ) {
        let errorMessage = "";
        var errors = error.response.data.errors;
        var keys = Object.keys(errors);
        for (let j = 0; j < keys.length; j++) {
          errorMessage += errors[keys[j]] + " , \n";
        }
        toast.error(errorMessage);
      } else if (error.response.data) {
        toast.error(
          error.response.data.Message
            ? error.response.data.Message
            : error.response.data.message
        );
      } else {
        toast.error("Error while processing the request");
      }
    } else {
      toast.error("Error while processing the request");
    }

    return false; // return false on error
  }
};

export const updateDeliveryUser = (formValues) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post("api/User/UpdateDeliveryUser", formValues);

    if (data.response) {
      dispatch({
        type: CREATE_DELIVERY_USER,
        payload: data.response,
      });
    }

    dispatch(hideLoading());

    if (data.statusCode === 400) {
      toast.error(data.message);
      return false; // explicitly return
    } else {
      toast.success("User updated successfully");
      return true; // explicitly return
    }
  } catch (error) {
    dispatch(hideLoading());

    if (error.response) {
      if (error.response.status === 401) {
        logout();
        history.push("/login");
        history.go("/login");
      } else if (
        error.response.status === 400 &&
        error.response.data.errors
      ) {
        let errorMessage = "";
        var errors = error.response.data.errors;
        var keys = Object.keys(errors);
        for (let j = 0; j < keys.length; j++) {
          errorMessage += errors[keys[j]] + " , \n";
        }
        toast.error(errorMessage);
      } else if (error.response.data) {
        toast.error(
          error.response.data.Message
            ? error.response.data.Message
            : error.response.data.message
        );
      } else {
        toast.error("Error while processing the request");
      }
    } else {
      toast.error("Error while processing the request");
    }

    return false; // return false on error
  }
};



export const getDeliveryUsers = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/User/GetDeliveryUsersList`, requestData)
    .then(({ data }) => {
      if (data && data.response)
        dispatch({
          type: GET_DELIVERY_USER_LIST,
          payload: data.response,
        })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const getQRorTillDetails = (distributorId) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .get(
      `api/MfiMerchantTill/GetMfiMerchantTillByDistributor/${distributorId}/distCenter`
    )
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_QRTILLDETAILS,
        payload: data.response,
      })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const deleteDeliveryUser = (id) => async (dispatch) => {
  if (!id) return
  dispatch(showLoading())
  await axios
    .delete(`api/User/DeleteDeliveryUser/${id}`)
    .then(() => {
      // dispatch({ type: DELETE_BANKDETAILS, payload: id })
      dispatch(hideLoading())
      toast.success('Record deleted successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
